<template>
  <div>
    <tab-title :tabList="tabList" url="patrol"></tab-title>
    <div class="router-section">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import TabTitle from '@/components/TabTitle'
export default {
  name: 'Patrol',
  components: { TabTitle },
  data () {
    return {
      tabList: [{
        label: '巡查任务',
        name: 'taskList'
      }, {
        label: '巡查问题',
        name: 'issueList'
      }]
    }
  },
  created () {
    // ...
  },
  methods: {
  }
}
</script>

<style scoped lang='scss'>
  .router-section {
    padding: 10px;
  }
</style>
